import Vue from 'vue';
import Vuex, { StoreOptions, MutationTree, ActionTree } from 'vuex';
import { default as axios, AxiosResponse } from 'axios';
import { IRootState, IUserState, IDataState, IFilterState } from './contract';
import { user } from './userStore';
import { data } from './dataStore';
import { filter } from './filterStore';
import { IRootHypermediaRepresentation } from '@/contracts/RootContract';

Vue.use(Vuex);

const exportState: IRootState = {
    root: null,
    appLoaded: false,
    commandManager: null,
    dataSourceLoader: null,
    dataFiltersManager: null,
    gui: null
};

const mutations: MutationTree<IRootState> = {
    rootLoaded(state, payload: IRootHypermediaRepresentation) {
        state.root = payload;
    }
};

const actions: ActionTree<IRootState, IRootState> = {
    async fetchRoot({ commit, state }): Promise<void> {
        if (!state.root) {
            const response: AxiosResponse<IRootHypermediaRepresentation> = await axios.get('/api');
            await commit('rootLoaded', response && response.data);
        }
    }
};

const storeOptions: StoreOptions<IRootState> = {
    state: exportState,
    mutations,
    actions,
    modules: {
        user,
        data,
        filter
    }
};

// Class + interface to make typescript happy when writing something like store.state.barometer...
class BeehiveStore extends Vuex.Store<IRootState> {
    state: IBeehiveState;

    constructor(store: StoreOptions<IRootState>) {
        super(store);
    }
}

export interface IBeehiveState extends IRootState {
    user: IUserState;
    data: IDataState;
    filter: IFilterState;
}

export default new BeehiveStore(storeOptions);
